export default __webpack_public_path__ + "static/screen-f121286944db06ffed7eaa90655f82e8.png";